module.exports = __webpack_public_path__ + "img/IMG_9701_L_WoodMatted_MockedUp.5d4e6092.jpg";